import React, {Component} from 'react';

export default class DropDownOptions {

    /**
     * Get array of options for select from array of data
     *
     * @param {array} array - array of object with value and lable fields
     * @param {string} idField - name of the key which correspond to name of id's field key in the object item
     * @param {string} valueField - name of the key which correspond to name of value's field key in the object item
     *
     * @example DropDownOptions.getOptions(workingTimes, 'id', 'value')
     *
     * @return {Array} - array of objects { value: id, label: value }
     *
     * */

    static getOptions(array, idField, valueField) {

        return array.map((option) => {
            return { value: option[idField], label: option[valueField] };
        })
    }
};


// WEBPACK FOOTER //
// ./web/src/components/helpers/DropDownOptions.jsx